import { render, staticRenderFns } from "./NoneTransition.vue?vue&type=template&id=1c860928&scoped=true"
import script from "./NoneTransition.vue?vue&type=script&lang=ts"
export * from "./NoneTransition.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c860928",
  null
  
)

export default component.exports